import classNames from "classnames";

export default function TaxHarvestingCard({ title, subtitle, value }) {
  return (
    <div className="c-tax-harvesting-cards__card">
      <div className="c-tax-harvesting-cards__content">
        <p className="c-tax-harvesting-cards__title">{title}</p>
        <p
          className={classNames(
            "c-tax-harvesting-cards__amount",
            value < 0 && "is-negative",
          )}
        >
          {value}
        </p>
        {subtitle && <p className="c-tax-harvesting-cards__caption">{subtitle}</p>}
      </div>
    </div>
  );
}
